function startObserver() {
    let isDebuggingEnabled = false;

    function checkAvailability(){
        let isProductUnavailable = false;
        let isDebuggingEnabled = false;

        // read from localStorage
        const breezeDebug = localStorage.getItem("breezeDebug");

        if (breezeDebug && breezeDebug.toLowerCase() === "true") {
            isDebuggingEnabled = true;
        }
        
        //On the basis of add to cart button/sold out button
        const addToCartButtons = document.querySelectorAll("button[name='add']");

        addToCartButtons.forEach((btn) => {
            if (btn !== null) {
                const disabled = btn.disabled;
                if(disabled !== null && disabled !== undefined && disabled === true){
                    isProductUnavailable = true;
                }

                if (isDebuggingEnabled) {
                    console.log(">>>>> addToCartButton status", {disabled,isProductUnavailable}, btn);
                }
            }
        });

        return isProductUnavailable;
    }

    function disableBreezeButtons(){
        const breezeButtons = document.getElementsByClassName("breeze-button-container");

        for(let i = 0; i < breezeButtons.length; i++){
            breezeButtons[i].style.display = "none";
            if(isDebuggingEnabled){
                console.log(">>>>> disableBreezeButtons status disable for:", breezeButtons[i]);
            }

        }
    }

    function enableBreezeButtons(){
        const breezeButtons = document.getElementsByClassName("breeze-button-container");

        for(let i = 0; i < breezeButtons.length; i++){
            breezeButtons[i].style.display = "block";
            if(isDebuggingEnabled){
                console.log(">>>>> disableBreezeButtons status enable for:", breezeButtons[i]);
            }

        }
    }

    const observer = new MutationObserver(() => {
        const isProductUnavailable = checkAvailability();

        if(isProductUnavailable){
            disableBreezeButtons();
        }
        else {
            enableBreezeButtons();
        }

    });

    observer.observe(document.body, {
        childList: true,     // watch for added/removed elements
        attributes: true,    // watch for attribute changes
        characterData: true, // watch for text changes
        subtree: true        // include everything inside <body>
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    startObserver();
});